import React, { useEffect, useMemo, useState } from "react";
import style from "../../PagesStyles/AdminPurchase.module.css";
import LotAuditReport from "Components/support/customervendor/LotAuditReport";

import AdminHeading from "../Heading/AdminHeading";
import AdminBreadCrump from "../Heading/AdminBreadCrump";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import {
  fetchAllCategoryList,
  fetchAllProductTypes,
  fetchAllRDPurchaseList,
  fetchLotAuditReports,
  fetchVendorsList,
} from "services/invoiceServices";
import { useForm } from "react-hook-form";
import ReportTable from "Components/support/customervendor/ReportTable";
import { FaSearch } from "react-icons/fa";
import { a751 } from "Components/Api/RootApiPath";
import { fetchAllCategories } from "services/generalService";
import PartyOutstandingReport from "Components/support/customervendor/PartyOutstandingReport";

const tabs = [
  { label: "Purchase Register", link: "/purchase" },
  { label: "Lot Audit", link: "/purchaseReport?report=1" },
  { label: "Party Outstanding Report", link: "/purchaseReport?report=2" },
];

const LotAuditColumns = [
  { key: "serialNumber", label: "Sr No", type: "read", priority: 2 },
  { key: "PurchaseEntryDate", label: "Date", type: "read", priority: 1 },

  {
    key: "VendorName",
    label: "Vendor Name",
    type: "read",
    priority: 3,
  },
  { key: "LotNumber", label: "Lot No", type: "read", priority: 5 },
  { key: "TotalWeight", label: "Purchase Total Wt", type: "read", priority: 4 },
  {
    key: "PackingWeight",
    label: "Purchase Packing Wt",
    type: "read",
    priority: 5,
  },
  { key: "GrossWeight", label: "Purchase Gross Wt", type: "read", priority: 6 },
  { key: "NetWeight", label: "Purchase Net Wt", type: "read", priority: 7 },
  { key: "NetWeight", label: "Sale Gross Wt", type: "read", priority: 7 },
  { key: "NetWeight", label: "Sale Net Wt", type: "read", priority: 7 },
  { key: "NetWeight", label: "Difference Gross Wt", type: "read", priority: 7 },
  { key: "NetWeight", label: "Difference Net Wt", type: "read", priority: 7 },
  // { key: "TotalGSTAmount", label: "Action", type: "read", priority: 9 },
];
const OutstandingColumns = [
  { key: "serialNumber", label: "Sr No", type: "read", priority: 2 },
  { key: "PurchaseEntryDate", label: "Vendor Name", type: "read", priority: 1 },

  {
    key: "VendorName",
    label: "Balance Fine Gold",
    type: "read",
    priority: 3,
  },
  { key: "LotNumber", label: "Balance Fine Silver", type: "read", priority: 5 },
  { key: "TotalWeight", label: "Balance Amount", type: "read", priority: 4 },
  {
    key: "PackingWeight",
    label: "Advance Amount",
    type: "read",
    priority: 5,
  },
];

const PurchaseReportNew = () => {
  const navigate = useNavigate();
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;

  const [lotAudit, setLotAudit] = useState([]);
  const [approvedItems, setApprovedItems] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  const { data: allVendors } = useQuery({
    queryKey: ["purchase/lotAudti/getVendorsList", clientCode],
    queryFn: fetchVendorsList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const { data: allRdPurchaseItems } = useQuery({
    queryKey: ["allRdPurchaseItems", clientCode],
    queryFn: fetchAllRDPurchaseList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const { data: allCategories } = useQuery({
    queryKey: ["purchase/logAudit/allCategories", clientCode],
    queryFn: fetchAllCategories,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });

  const { data: allProductTypes } = useQuery({
    queryKey: ["allProductTypes", clientCode],
    queryFn: fetchAllProductTypes,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });


  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      SearchQuery: "",
      stockType: "",
      category: "",
      vendor: "",
    },
  });

  const approveItem = (lotNumber) => {
    // Find the approved item and remove it from lotAudit
    const updatedLotAudit = lotAudit.filter(
      (item) => item.LotNumber !== lotNumber
    );
    const approvedItem = lotAudit.find((item) => item.LotNumber === lotNumber);

    if (approvedItem) {
      // Update IsApproved to true and move to approvedItems
      approvedItem.IsApproved = true;
      setApprovedItems((prevApproved) => [...prevApproved, approvedItem]);
    }

    setLotAudit(updatedLotAudit);
  };

  useEffect(() => {
    console.log("approvedItems", approvedItems);
    console.log("lotAudit>>", lotAudit);
  }, [approvedItems, lotAudit]);

  // const fetchAllCategory = async () => {
  //   let fromDate = "2024-08-01";
  //   let toDate = "2024-11-15";

  //   const formData = {
  //     ClientCode: clientCode,
  //     FromDate: fromDate,
  //     ToDate: toDate,
  //   };
  //   const response = await fetch(a751, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(formData),
  //   });
  //   const data = await response.json();
  //   console.log(data);
  //   setLotAudit(data);
  //   try {
  //     if (data.length > 0) {
  //       setLotAudit(data);
  //     } else {
  //       setActive("addNew");
  //       document
  //         .getElementById("addCategoryListTitle")
  //         .classList.add("activeCategoryTitle");
  //       document
  //         .getElementById("addCategoryListLogo")
  //         .classList.add("activeCategoryLogo");
  //       document.getElementById("addCategoryListTitle").click();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   fetchAllCategory();
  // }, []);

  const [filteredLotNumbers, setFilteredLotNumbers] = useState([]);
  const [activeList, setActiveList] = useState(1);
  const searchParam = useSearchParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const report = searchParams.get("report");
  const SearchQuery = watch("SearchQuery");
  const AsigneeOption = watch("AsigneeOption");
  const Name = watch("Name");
  const MaterialType = watch("MaterialType");

  useEffect(() => {
    let rcvdData = allRdPurchaseItems?.reverse();
    let orderedData = rcvdData?.map((item, index) => {
      item.serialNumber = index + 1;
      return item;
    });
    const allLotNumbersList = orderedData?.map((x) => x.LotNumber);
    setFilteredLotNumbers(allLotNumbersList);
  }, [allRdPurchaseItems,report]);


 

  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: "130px" }}>
        <AdminBreadCrump
          title={"Purchase"}
          companyName={"Loyalstring"}
          module={"Trading"}
          page={"Purchase"}
        />
        <div className={style.adminAddCategoryMainBox}>
          <div className="adminAddCategoryInnerBox">
            <div
            // className={
            //   active === "List" ? "adminCategoryListMainBox" : "none"
            // }
            >
             

              <div className={style.container}>
                {tabs?.map((tab, index) => (
                  <div
                    key={tab}
                    className={`${style.tab} ${
                      report == index ? style.active : ""
                    }`}
                    onClick={() => navigate(tab?.link)}
                  >
                    {tab?.label}
                  </div>
                ))}
              </div>
            </div>

            {/* ------------------------table starts here------------------ */}

            {report == 1 && (
              <LotAuditReport
              clientCode={clientCode}
              allCategories={allCategories}
              allVendors={allVendors}
              />
            )}
            {report == 2 && (
              <PartyOutstandingReport
              clientCode={clientCode}
              allCategories={allCategories}
              allVendors={allVendors}
            />
            )}
           
            {/* ------------------------table ends here------------------ */}
            <div
              style={{ margin: 0 }}
              // className={
              //   active !== "List" ? "adminCategoryListMainBox" : "none"
              // }
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseReportNew;
